import produce from "immer";
import moment from "moment";
import {
  PROJECT_CREATE_SUCCESS,
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_FAILURE,
  PROJECT_LIST_REQUEST,
  PROJECT_LIST_SUCCESS,
  PROJECT_LIST_FAILURE,
  PROJECT_DELETE_SUCCESS,
  PROJECT_DELETE_REQUEST,
  PROJECT_DELETE_FAILURE,
  PROJECT_UPLOAD_DATASET_PROGRESS,
  PROJECT_UPDATE_DURATION,
  RECORDING_ADD_LIST,
  RECORDING_LIST_SUCCESS,
  RECORDING_BULK_UPDATE_REQUEST,
  RECORDING_BULK_UPDATE_SUCCESS,
  RECORDING_BULK_UPDATE_FAILURE,
  DATASET_PROCESS_SUCCESS,
  DATASET_PROCESS_FAILURE,
  DATASET_DELETE_SUCCESS,
} from "../actions/types";
import { projectStates } from "../constants";

const projectsInitState = {
  ids: [],
  hash: {},
  loading: false,
  cachedAt: null,
  error: {},
};

export const projects = (state = projectsInitState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // ---------------- REQUEST ----------------
      case PROJECT_LIST_REQUEST:
        draft.loading = true;
        break;
      case PROJECT_CREATE_REQUEST:
        const tmpId = action.tmpId;
        draft.ids.push(tmpId);
        draft.hash[tmpId] = action.project;
        draft.hash[tmpId].id = tmpId;
        draft.hash[tmpId].state = projectStates.UPLOADING;
        break;
      case PROJECT_UPLOAD_DATASET_PROGRESS:
        draft.hash[action.tmpId]["uploaded"] = action.progress;
        if (action.progress === 100) {
          draft.hash[action.tmpId].state = projectStates.PROCESSING;
        }
        break;
      case PROJECT_DELETE_REQUEST:
        draft.hash[action.projectId].state = "processing";
        break;

      // ---------------- SUCCESS ----------------
      case PROJECT_LIST_SUCCESS:
        draft.ids = [];
        draft.hash = {};
        draft.loading = false;
        action.projects.forEach((project) => {
          draft.ids.push(project.id);
          draft.hash[project.id] = project;
          draft.hash[project.id].recordings = [];
        });
        draft.cachedAt = moment();
        break;
      case PROJECT_CREATE_SUCCESS:
        delete draft.hash[action.tmpId];
        draft.ids = draft.ids.filter((id) => id !== action.tmpId);
        draft.ids.push(action.project.id);
        draft.hash[action.project.id] = action.project;
        break;
      case DATASET_PROCESS_SUCCESS:
        const projectId = action.project.id;
        draft.hash[projectId] = action.project;
        draft.hash[projectId].recordings = action.recordings.map(
          (rec) => rec.id
        );
        break;
      case PROJECT_DELETE_SUCCESS:
        draft.hash[action.project.id] = action.project;
        break;
      case DATASET_DELETE_SUCCESS:
        delete draft.hash[action.projectId];
        draft.ids = draft.ids.filter((id) => id !== action.projectId);
        break;

      // ---------------- FAILURE ----------------
      case PROJECT_LIST_FAILURE:
        draft.loading = false;
        draft.error = action.error;
        break;
      case PROJECT_CREATE_FAILURE:
        delete draft.hash[action.tmpId];
        draft.ids = draft.ids.filter((id) => id !== action.tmpId);
        break;
      case DATASET_PROCESS_FAILURE:
        draft.hash[action.project.id] = action.project;
        break;
      case PROJECT_DELETE_FAILURE:
        draft.hash[action.projectId].state = "error";
        break;

      // ---------------- RECORDINGS  ----------------
      case PROJECT_UPDATE_DURATION:
        draft.hash[action.projectId].recorded_duration += action.duration;
        break;
      case RECORDING_ADD_LIST:
      case RECORDING_LIST_SUCCESS:
        draft.hash[action.projectId].recordings = action.recordings.map(
          (rec) => rec.id
        );
        break;
      case RECORDING_BULK_UPDATE_REQUEST:
        draft.hash[action.projectId].state = projectStates.PROCESSING;
        break;
      case RECORDING_BULK_UPDATE_SUCCESS:
      case RECORDING_BULK_UPDATE_FAILURE:
        draft.hash[action.projectId].state = projectStates.OK;
        break;
      default:
    }
  });
